<router-outlet />
<app-preloader *ngIf="loading$ | async"></app-preloader>

